import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ReportIssueBar = ({ toolName }) => {
  const subject = encodeURIComponent(`Issue Report - ${toolName || 'Lawra AI Tool'}`);
  const body = encodeURIComponent(`Hi Lawra AI Team,\n\nI encountered an issue while using ${toolName || 'a tool'}.\n\nDescription of the issue:\n\nSteps to reproduce:\n1.\n2.\n3.\n\nThank you`);

  return (
    <div className="report-issue-bar" data-testid="report-issue-bar">
      <AlertTriangle size={16} />
      <span>Encountered a problem?</span>
      <a href={`mailto:support@lawra-ai.com?subject=${subject}&body=${body}`} className="report-issue-link">
        Report an Issue
      </a>
    </div>
  );
};

export default ReportIssueBar;
